// extracted by mini-css-extract-plugin
export default {"zoomControls":"qca-z","zoomControlButton":"rca-z","zoomBanner":"sca-z","bannerButton":"tca-z","imageButton":"uca-z","zoom":"vca-z","zoomContent":"wca-z"};